<!--协同备课学科统计图-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -40px;"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";


export default {
    name: "areaTeaSubjectEchart",
    props: {
        id:{
            type: String,
            default:"area_tea_subject_echart"
        },
        itemList:{
            type: Array,
            default:[]
        },
        countList:{
            type: Array,
            default:[]
        },
    },
    watch:{},
    data() {
        return {
            barChart: null, // 柱状图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                grid: {
                    left: '40px',
                    right: '10px',
                    // top: '10%',
                    // bottom: '10%'
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#fff' // 红色
                        }
                    },
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:45,
                        textStyle: {    //文字样式
                            color: "#fff",
                            fontSize: 8,
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {    //文字样式
                            color: "#fff",
                            fontSize: 10,
                        }
                    },
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        color: [
                            '#68bbc4',
                        ],
                        barMaxWidth: 50,
                        showBackground: true,
                        barCategoryGap: '8',
                        backgroundStyle: {
                            color: 'rgba(180, 180, 180, 0.2)'
                        }
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.barChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.xAxis.data = []
            // this.chartOption.series[0].data = [10,4,8,12,5];
            // this.chartOption.xAxis.data = ['语文','数学','英语','物理','化学']
            this.chartOption.xAxis.data = this.itemList
            this.chartOption.series[0].data = this.countList;
            this.barChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 100px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 40px);
    }
}
</style>